import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  get_applied_jobs_list_candidate_action,
  get_applied_job_details_candidate_action,
  get_assigned_interview_kit_job_action,
} from "../../../redux/_actions";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function useMentorJobBoardExpanded(props) {
  const [allJobs, setallJobs] = useState({});
  const [jobDetails, setjobDetails] = useState({});
  const [loading, setloading] = useState(false);
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [assignedInterviewKitLoading, setAssignedInterviewKitLoading] =
    useState(false);
  const [assignedInterviewKit, setAssignedInterviewKit] = useState({});

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const jobCardDivParentRef = useRef(null);

  const { appliedJobsListData } = useSelector(
    (state) => state.get_applied_jobs_list_candidate_reducer
  );

  const { appliedJobDetailsData } = useSelector(
    (state) => state.get_applied_job_details_candidate_reducer
  );

  const { interviewKitAssignedData } = useSelector(
    (state) => state.get_assigned_interview_kit_job_reducer
  );

  //get page number
  useEffect(() => {
    const index = location?.state && location.state?.index;
    if (index) {
      let pageNum = Math.floor(index / 10) + 1;
      setCurrentPage(pageNum);
    } else {
      setCurrentPage(1);
    }
  }, []);

  useEffect(() => {
    if (currentPage !== null) {
      callApi();
    }
  }, [currentPage]);

  //get current job or job on zero number
  useEffect(() => {
    const job_id = location?.state && location.state?.job_id;
    if (job_id) {
      onCurrentJobCardChange(job_id);
      setJobId(job_id);
    } else if (jobId === null) {
      if (appliedJobsListData?.data) {
        let id = appliedJobsListData.data?.results[0].job_posting;
        onCurrentJobCardChange(id);
      }
    }
  }, [allJobs]);

  useEffect(() => {
    if (appliedJobsListData?.data) {
      setallJobs(appliedJobsListData?.data);
    }
  }, [appliedJobsListData]);

  //job details
  useEffect(() => {
    if (appliedJobDetailsData?.data !== undefined) {
      setjobDetails(appliedJobDetailsData?.data);
    }
  }, [appliedJobDetailsData]);

  useEffect(() => {
    if (interviewKitAssignedData?.data) {
      setAssignedInterviewKit(interviewKitAssignedData?.data[0]);
    }
  }, [interviewKitAssignedData]);

  //get assigned assessment kit
  useEffect(() => {
    if (
      appliedJobDetailsData?.data &&
      appliedJobDetailsData.data?.interview_stage === "assessment"
    ) {
      callInterviewKitAssignedApi();
    }
    setAssignedInterviewKit({});
  }, [appliedJobDetailsData]);

  const callApi = async () => {
    setloading(true);
    await dispatch(get_applied_jobs_list_candidate_action(currentPage));
    setloading(false);
  };

  const callInterviewKitAssignedApi = async () => {
    setAssignedInterviewKitLoading(true);
    await dispatch(
      get_assigned_interview_kit_job_action(
        appliedJobDetailsData?.data &&
          appliedJobDetailsData.data?.job_details.id
      )
    );
    setAssignedInterviewKitLoading(false);
  };

  const onCurrentJobCardChange = async (id) => {
    setJobDetailsLoading(true);
    await dispatch(get_applied_job_details_candidate_action(id));
    setJobDetailsLoading(false);
  };

  const onCurrentPageChange = (page) => {
    setCurrentPage(page);
    setJobId(null);
  };

  const onTakeInterviewClick = () => {
    navigate(
      `/assigned-interview-kit?appliedJob=${
        jobDetails?.job_details && jobDetails.job_details?.id
      }&applicant=${jobDetails?.id}&interviewKit=${
        assignedInterviewKit?.interview_kit
      }`
    );
  };

  const onScheduleLinkClick = () => {
    if (jobDetails?.schedule_link) {
      navigate(
        `/schedule-interview?event_link=${jobDetails?.schedule_link}&applicant=${jobDetails?.id}`
      );
    } else showWarningMessage("Event Link not assigned yet.");
  };

  // const toggleJobOfferModal

  const onViewJobOfferClick = async () => {
    if (jobDetails?.interview_stage === "offer") {
      if (jobDetails?.is_job_offered === true) {
        navigate(`/job-offered/offer-terms/${jobDetails?.id}`);
      } else showWarningMessage("Offer terms not uploaded yet.");
    }
  };

  
  const onViewCompany = (id) => {
    navigate(`/company-info/${id}`, {
      state: {
        companyId: id,
      },
    })
  }

  return {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    currentPage,
    assignedInterviewKit,
    jobCardDivParentRef,
    onViewCompany,
    onCurrentJobCardChange,
    onCurrentPageChange,
    onTakeInterviewClick,
    onScheduleLinkClick,
    onViewJobOfferClick,
  };
}
export default useMentorJobBoardExpanded;
